import React, { useEffect } from "react";
import { matchRoute } from "@/prefetch-routes";
import qs from "query-string";
import { Route, Switch, useHistory } from "react-router-dom";
import MasterContainer from "@/containers/master";
import ClientContainer from "@/containers/client";
import SaloonContainer from "@/containers/saloon";
import SafeDeal from "_p/safe-deal/container";
import Partners from "_p/partners/container";
import Ambassador from "_p/ambassador/container";
import ThankYou from "_p/thankyou/container";
import BlogContainer from "@/containers/blog";
import HomeAndSearchContainer from "@/containers/home-and-search";
import Portfolio from "_p/portfolio/container";
import PrivacyPolicy from "_p/privacy-policy";
import Agreement from "_p/agreement";
import VerifyEmail from "_p/verify-email/container";
import VerifyPhone from "_p/verify-phone/container";
import RestorePassword from "_p/restore-password";
import Review from "_p/review/container";
import NotFound from "_p/404";
import VerifyClientInvite from "_p/verify-client-invite/container";
import VerifySaloonInvite from "_p/verify-saloon-invite/container";
import { ProgressEmitter } from "_c/GlobalProgress/emitter";
import ViberSubscribe from "_p/viber-subscribe";
import MsgrSubPage from "_p/messenger-sub";
import Entrypoint from "_p/entrypoint";
import CityPage from "@/pages/city";
import { useStore } from "react-redux";
import { useQueryClient } from "react-query";
import { Selectors as UserSelectors } from "@/store/user/selectors";

const Router = () => {
  const history = useHistory();
  const reduxStore = useStore();
  const queryClient = useQueryClient();
  useEffect(() => {
    let prevLoc: Maybe<string>;
    const unregister = history.listen((baseLoc) => {
      const loc = baseLoc.pathname + baseLoc.search;
      if (loc !== prevLoc) {
        const [matched, matchedParams] = matchRoute(baseLoc.pathname);
        const locale = UserSelectors.getLocale(reduxStore.getState());
        if (matched) {
          ProgressEmitter.start();
          matched
            .prefetch({
              matchedPath: matchedParams,
              ctx: {
                locale,
                queryClient,
                store: reduxStore,
                redirect(url) {
                  history.push(url);
                },
                throw(code, error) {
                  console.error(code, error);
                  history.push("/not-found");
                },
                query: qs.parse(baseLoc.search),
              },
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              setTimeout(() => ProgressEmitter.end(), 1);
            });
        }
      }
      prevLoc = loc;
    });
    return unregister;
  }, [queryClient, reduxStore]);
  return (
    <Switch>
      <Route exact path="/" component={HomeAndSearchContainer} />
      <Route path="/city" component={CityPage} />
      <Route path="/search" component={HomeAndSearchContainer} />
      <Route path="/messenger/sub/:token" component={MsgrSubPage} />
      <Route path="/entrypoint" component={Entrypoint} />
      <Route path="/master" component={MasterContainer} />
      <Route path="/app" component={MasterContainer} />
      <Route path="/client" component={ClientContainer} />
      <Route path="/salon" component={SaloonContainer} />
      <Route path="/blog" component={BlogContainer} />
      <Route path="/portfolio/:id" component={Portfolio} />
      <Route path="/review/:id" component={Review} />
      <Route exact path="/safe-deal" component={SafeDeal} />
      <Route exact path="/ambassador" component={Ambassador} />
      <Route exact path="/partners" component={Partners} />
      <Route exact path="/privacy-policy" component={PrivacyPolicy} />
      <Route exact path="/user-agreement" component={Agreement} />
      <Route exact path="/thankyou" component={ThankYou} />
      <Route path="/viber/subscribe/:token" component={ViberSubscribe} />
      <Route path="/verify-email/:code" component={VerifyEmail} />
      <Route
        path="/verify-client-invite/:code"
        component={VerifyClientInvite}
      />
      <Route path="/verify-phone/:code" component={VerifyPhone} />
      <Route
        path="/verify-saloon-invite/:code"
        component={VerifySaloonInvite}
      />
      <Route path="/restore-password/:code" component={RestorePassword} />
      <Route
        render={({ staticContext }) => {
          if (staticContext) {
            // @ts-ignore
            staticContext.notFound = true;
          }
          return <NotFound />;
        }}
      />
    </Switch>
  );
};
export default Router;
